import http from '../jslibs/axios/http';

//会员设置 会员等级列表
export const getMemberList = data => (http.get('/v1/cms/Member', data));
export const editMember = data => (http.put(`/v1/cms/Member/${data.uuid}`, data));

//会员设置 规格
export const getMemberUnit = data => (http.get('/v1/cms/MemberUnit', data));
export const addMemberUnit = data => (http.post('/v1/cms/MemberUnit', data));
export const editMemberUnit = data => (http.put(`/v1/cms/MemberUnit/${data.uuid}`, data));
export const deleteMemberUnit = uuid => (http.delete(`/v1/cms/MemberUnit/${uuid}`));

//会员设置 购买记录
export const getMemberOrderRecord = data => (http.get('/v1/cms/MemberOrderRecord', data));

//会员设置 设置列表
export const getSetMemberList = data => (http.get('/v1/cms/SetMember', data));
export const addSetMemberList = data => (http.post('/v1/cms/SetMember', data));
export const editSetMember = (data, id) => (http.put(`/v1/cms/SetMember/${id}`, data));